// PayPal front-end client id (public — safe in the bundle; the SECRET stays
// server-side in paypal.conf.php).
//
// ENV SWITCH — driven by the build, no manual edits needed:
//   • `npm run build-release` sets REACT_APP_PAYPAL_ENV=live    → live client id
//   • `npm run build-testing` sets REACT_APP_PAYPAL_ENV=sandbox → sandbox client id
//   • plain `npm start` / `npm run build` (no env) → sandbox (safe default)
// This stays in lock-step with the backend paypal.conf that the same build scripts write.
//
// The sandbox client id MUST belong to the SAME sandbox account that owns the
// sandbox plan_ids in plans.ts — otherwise PayPal rejects the subscription
// ("plan not found"). The value below is this project's sandbox app.
// Trimmed and lower-cased on purpose: the value used to arrive as "live " from a
// cmd.exe `set VAR=live & …`, and an invisible trailing space turned every release
// build into a sandbox build. The generators write .env.local now, but a value that
// only differs in whitespace must never decide which PayPal account is charged.
export const PAYPAL_SANDBOX =
  (process.env.REACT_APP_PAYPAL_ENV || "").trim().toLowerCase() !== "live";

// The build writes the id the backend uses into .env.local, so the browser and
// paypal.conf.php can no longer drift apart — they did, and a subscription created
// with one account's client id against another account's plan id is answered with
// RESOURCE_NOT_FOUND and no sale. The literals below only cover `npm start` without a
// generator run.
const PAYPAL_CLIENT_IDS = {
  sandbox: "ASDzGW8u7SIlQLlxhzw8Ccym2OnE4tNlDqsP8mFOFjfBoYhnEF-QhzRGVsO55G3GB8KlDZLKVXPa8YYV",
  live:    "BAAlfXyWFGiPL3Ettm1mBpaKwxVNibHpBwITgAG-HESOGdB9oUNx1FDtTNfK5TjORcDJIS-Gv9gKoe-hOE",
};

export const PAYPAL_CLIENT_ID =
  (process.env.REACT_APP_PAYPAL_CLIENT_ID || "").trim() ||
  (PAYPAL_SANDBOX ? PAYPAL_CLIENT_IDS.sandbox : PAYPAL_CLIENT_IDS.live);
